import { render, staticRenderFns } from "./OToggle.vue?vue&type=template&id=35c1fe7d&scoped=true"
import script from "./OToggle.vue?vue&type=script&lang=js"
export * from "./OToggle.vue?vue&type=script&lang=js"
import style0 from "./OToggle.vue?vue&type=style&index=0&id=35c1fe7d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c1fe7d",
  null
  
)

export default component.exports